import { render, staticRenderFns } from "./historyTrace.vue?vue&type=template&id=638e4144&scoped=true&"
import script from "./historyTrace.vue?vue&type=script&lang=js&"
export * from "./historyTrace.vue?vue&type=script&lang=js&"
import style0 from "./historyTrace.vue?vue&type=style&index=0&id=638e4144&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638e4144",
  null
  
)

export default component.exports